import { useMemo } from "react";
import { bindActionCreators } from "@reduxjs/toolkit";
import {
  useAppDispatch,
  useAppSelector,
  type RootState,
} from "../../../store/store";
import { authActions } from "../redux/slice";
import authThunks from "../redux/thunk";
import { clearAppSession } from "../../common/redux/globalActions";

export const useAuth = () => {
  const {
    access,
    refresh,
    user,
    expires_at,
    code_phrase,
    is_authenticated,
    login_method,
    singpass_verification,
  } = useAppSelector((state: RootState) => state.auth);

  const dispatch = useAppDispatch();

  return useMemo(() => {
    const actions = {
      ...authActions,
      ...authThunks,
      // clearAppError,
      clearAppSession
    };
    return {
      ...bindActionCreators(actions, dispatch),
      user,
      code_phrase,
      expires_at,
      accessToken: access,
      refreshToken: refresh,
      isAuthenticated: is_authenticated,
      login_method,
      singpass_verification
    };
  }, [
    dispatch,
    user,
    code_phrase,
    expires_at,
    is_authenticated,
    access,
    refresh,
    login_method,
    singpass_verification,
  ]);
};

export default useAuth;
